import Iconify from '../../components/Iconify';
import { ICON_SIZE_MAP } from '../../config';
import { ICONS } from '../icons';
import { IconProps } from '../types';

export const SearchIcon = ({ text, size = 'sm', sx }: IconProps) => {
  const iconSize = ICON_SIZE_MAP[size];

  if (!text) {
    return <Iconify icon={ICONS.SEARCH} width={iconSize} height={iconSize} sx={sx} />;
  }

  return (
    <>
      <Iconify icon={ICONS.SEARCH} width={iconSize} height={iconSize} sx={sx} /> {text}
    </>
  );
};
